import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useSiteSettings } from "@/lib/settings";
import { GuaranteeBadge } from "@/components/Guarantee";

const PATHS = [
  {
    to: "/test-soft-skills", testid: "checkup-cta", eyebrow: "Strada 1 · Gratuito",
    title: <>Check-up <span className="text-[#c4dcca]">Soft Skills.</span></>,
    text: "Vuoi prima capire a che punto sei? 27 domande, 5 minuti: ricevi il tuo profilo sulle 9 competenze del cambiamento, con i punti di forza e le skill da allenare per prime.",
    cta: "Inizia il check-up", note: "Autovalutazione educativa · le risposte restano sul tuo dispositivo",
  },
  {
    to: "/training-online", testid: "coaching-apply-cta", eyebrow: "Strada 2 · Training Online",
    title: <>Candidati <span className="text-[#c4dcca]">subito.</span></>,
    text: "Sai già che vuoi essere seguito? Salta il check-up e scopri il percorso di Training Online: da lì compili il primo passo e ti ricontatto io.",
    cta: "Scopri il percorso", guarantee: true, note: "Percorso di 90 giorni · gruppo a numero chiuso",
  },
];

const SeatsBadge = ({ s }) => {
  const open = s.enrollment_open && s.seats_left > 0;
  return (
    <p data-testid="lt-coaching-seats-left" className="relative mb-6 inline-flex w-fit items-center gap-2 border border-[#98bfa2]/40 px-4 py-2 font-mono text-xs uppercase tracking-widest text-[#c4dcca]">
      <span className={`h-2 w-2 rounded-full ${open ? "bg-[#98bfa2]" : "bg-[#f0a78f]"}`} />
      {!s.enrollment_open ? "Iscrizioni chiuse · lista d'attesa" : s.seats_left > 0 ? `${s.seats_left} ${s.seats_left === 1 ? "posto libero" : "posti liberi"} su ${s.coaching_seats}` : "Posti esauriti · lista d'attesa"}
    </p>
  );
};

const PathCard = ({ p, i, badge }) => (
  <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}>
    <div data-testid={`${p.testid}-card`}
      className="relative flex h-full flex-col overflow-hidden border border-[#98bfa2] bg-[#0b120e] p-7 transition-colors hover:bg-[#121c17] md:p-10">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#98bfa2]/15 blur-[100px]" />
      <p className="eyebrow relative mb-4">{p.eyebrow}</p>
      {badge}
      <h3 className="relative font-display text-4xl font-900 uppercase leading-[0.85] md:text-6xl">{p.title}</h3>
      <p className="relative mb-8 mt-6 max-w-xl flex-1 text-base text-[#a3b1aa] md:text-lg">{p.text}</p>
      <div className="relative flex flex-wrap items-center gap-x-6 gap-y-4">
        <Link to={p.to} data-testid={p.testid} className="group inline-flex w-fit items-center gap-3 bg-[#98bfa2] px-7 py-4 font-display text-lg font-800 uppercase text-[#050807] transition-colors hover:bg-[#c4dcca]">
          {p.cta} <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
      <p className="relative mt-4 font-mono text-[11px] text-[#a3b1aa]">{p.note}</p>
      {p.guarantee && <GuaranteeBadge />}
    </div>
  </motion.div>
);

export const CheckupCta = () => {
  const s = useSiteSettings();
  return (
  <div className="mt-16" data-testid="start-paths">
    <p className="eyebrow mb-4">Da dove partire</p>
    <h3 className="mb-8 max-w-3xl font-display text-3xl font-900 uppercase leading-none md:text-5xl">
      Due strade: <span className="text-[#c4dcca]">scegli tu.</span>
    </h3>
    <div className="grid gap-4 lg:grid-cols-2">
      {PATHS.map((p, i) => <PathCard key={p.testid} p={p} i={i} badge={p.testid === "coaching-apply-cta" ? <SeatsBadge s={s} /> : null} />)}
    </div>
  </div>
  );
};
